import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuotesUtil } from "../../../utility";
const useQuotes = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(state => state.auth)
  const { all_Quotes } = useSelector(state => state.quotes)
  const [searchValue, setSearchValue] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [status, setStatus] = useState("publish");
  const [page, setPage] = useState(() => {
    const p = parseInt(localStorage.getItem("quotePage"), 10);
    return !isNaN(p) ? p : 1;
  });
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const gettingQuotes = () => {
    fetchQuotesUtil({
      page,
      search: searchValue,
      pageSize,
      status,
      setLoading,
      dispatch,
      setTotalPages,
    });
  }
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingQuotes()
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [page, searchValue, status, pageSize]);
  useEffect(() => {
    let search = localStorage.getItem('quoteSearch')
    setSearchValue(search)
  }, [])
  return {
    quotes: all_Quotes || [],
    searchValue,
    setSearchValue,
    selectedData,
    setSelectedData,
    selectedRows,
    setSelectedRows,
    status,
    setStatus,
    user,
    page,
    setPage,
    pageSize,
    setPageSize,
    loading,
    totalPages,
    gettingQuotes
  };
};
export default useQuotes;
